module.exports = __webpack_public_path__ + "img/__icon_INNA_CYSTERNA.2cc0f92c.svg";